import React from 'react';
import { Form, Select, Input, DatePicker } from 'antd';
import { Department, Member } from '../../../../services/organizationAPI';

const { Option } = Select;

interface MemberPositionTabProps {
    departments: Department[];
    members: Member[];
    currentMemberId?: string;
}

export const MemberPositionTab: React.FC<MemberPositionTabProps> = ({ departments, members, currentMemberId }) => {
    return (
        <div className="form-section">
            <Form.Item name="department" label="所属部门">
                <Select allowClear placeholder="选择部门">
                    {departments.map(d => (
                        <Option key={d.id} value={d.id}>{d.name}</Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item name="job_title" label="职位">
                <Input placeholder="如：运营专员、采购经理" />
            </Form.Item>

            <Form.Item name="supervisor" label="直属上级">
                <Select allowClear showSearch optionFilterProp="children" placeholder="选择直属上级">
                    {members.filter(m => m.id !== parseInt(currentMemberId || '0')).map(m => (
                        <Option key={m.user_id} value={m.user_id}>
                            {m.username} {m.job_title ? `(${m.job_title})` : ''}
                        </Option>
                    ))}
                </Select>
            </Form.Item>

            <Form.Item name="hire_date" label="入职日期">
                <DatePicker style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item name="contract_end_date" label="合同到期日">
                <DatePicker style={{ width: '100%' }} />
            </Form.Item>

            <Form.Item name="employee_status" label="在职状态">
                <Select>
                    <Option value="active">在职</Option>
                    <Option value="probation">试用期</Option>
                    <Option value="resigned">离职</Option>
                </Select>
            </Form.Item>

            <Form.Item name="role" label="系统角色">
                <Select>
                    <Option value="admin">管理员</Option>
                    <Option value="member">普通成员</Option>
                </Select>
            </Form.Item>
        </div>
    );
};
